import { Injectable } from "@angular/core";
import Utils from '../utils';
import { StorageKeys } from "../_constants";
import { RequestHelperProvider, StorageServiceProvider } from "./services";
@Injectable({
  providedIn: 'root' 
})
export class StagingServiceProvider {
    public stagingRemoteURL = Utils.GetStagingRemoteServer();
    constructor(
        private helper: RequestHelperProvider,
        private storage: StorageServiceProvider
    ) {

    }

    // Delivery point keys are stored in an order line remark, so they are capped in length.
    private static readonly DeliveryPointKeyMaxLength = 50;

    public static NormalizeDeliveryPointKey(key: any): string {
        return (key ?? '').toString().trim().substring(0, StagingServiceProvider.DeliveryPointKeyMaxLength);
    }

    public static BuildDeliveryPointKey(id: any, name: string): string {
        return StagingServiceProvider.NormalizeDeliveryPointKey(`${id} - ${name}`);
    }

    public async GetCustomerDeliveryPointOptions(customerId: string): Promise<{ Key: string, Value: string }[]> {
        try {
            const response = await this.GetCustomerDeliveryPoints(customerId);
            const data = response?.TransactionObject?.Success && response.TransactionObject.Data;
            if (!data) {
                return [];
            }

            return data.map((item: any) => ({
                Key: StagingServiceProvider.BuildDeliveryPointKey(item.Id, item.DeliveryPointName),
                Value: item.DeliveryPointName
            }));
        } catch (ex) {
            return [];
        }
    }

    public async GetCustomerDeliveryPoints(CustomerId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let settings = this.storage.get(StorageKeys.Settings);;
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenantId = dataSet.TenantID;
            let agentId = localStorage.getItem('AgentId');
            let userId = JSON.parse(localStorage.getItem("agrisLicense")).username;


            let body = {
                AgentId: agentId,
                TenantId: tenantId,
                CustomerId: CustomerId,
                UserName: null

            };


            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            let remoteUrl = this.stagingRemoteURL;
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

            this.helper.Post(
                (data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${remoteUrl}/WarehouseDeliveryLocation/GetDeliveryLocations`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }


    public async SaveCustomerDeliveryPoint(payload: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let settings = this.storage.get(StorageKeys.Settings);;
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let tenantId = dataSet.TenantID;
            let agentId = localStorage.getItem('AgentId');
            let userId = JSON.parse(localStorage.getItem("agrisLicense")).username;

            let body: any = [];
            for (let index = 0; index < payload.length; index++) {
                const element = payload[index];
                element.AgentId = agentId;
                element.TenantId = tenantId;
                element.CreatedBy = userId;

                body.push(element);
            }

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            let remoteUrl = this.stagingRemoteURL;
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

            this.helper.Post(
                (data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${remoteUrl}/WarehouseDeliveryLocation/InsertUpdateDeliveryLocation`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }

}